const W = window
const D = document
W.on = function (el, event, cb) {
  if(el){
    el.removeEventListener(event, cb)
    el.addEventListener(event, cb)
  }
}
W.off = function (el, event, cb) {
  if(el){
    el.removeEventListener(event, cb)
  }
}
if (W.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

W.trigger = function (element, eventName, bubbles = true, cancelable = true) {
  if ("createEvent" in document) {
    let evt = document.createEvent("HTMLEvents");
    evt.initEvent(eventName, bubbles, cancelable);
    element.dispatchEvent(evt);
  } else {
    // IE 8
    let e       = document.createEventObject();
    e.eventType = eventName;
    element.fireEvent('on' + e.eventType, e);
  }
}
// Create Element.remove() function if not exist
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function() {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}
W.getXHR = function () {
  let xhr = null;
  return function (method, url, cb, data, err) {
    if (xhr) {
      xhr.abort()
    }
    xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    if(data){
      let formData = new FormData();
      for(let i in data){
        formData.append(i, data[i]||'');
      }

      xhr.send(formData);
    }else{
      xhr.send();
    }
    xhr.onload = function () {
      if (xhr.status === 200) {
        cb(xhr.response)
      } else {
        console.log(xhr, xhr.status)
        err(xhr)
      }
    };
  }
}
